import React from "react";
import { FlameIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const claimed = TOTAL_SPOTS - SPOTS_LEFT;
  return <div className="rounded-2xl border border-alert/25 bg-[#FFF4EC] p-4 text-left" data-id="element-61" data-mp="2l5664n689fxh">
      <p className="flex items-start gap-2 text-[15px] font-bold leading-snug text-ink" data-id="element-62" data-mp="2l33g4352rmsr">
        <FlameIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-63" data-mp="2q1wjv3uk7zfq" />
        <span data-id="element-64" data-mp="2b5fbmlho30xe">
          Only <span className="text-alert" data-id="element-65" data-mp="2b934difafjb2">{SPOTS_LEFT} spots left</span> at the promotional price
        </span>
      </p>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-alert/15" role="progressbar" aria-valuenow={claimed} aria-valuemin={0} aria-valuemax={TOTAL_SPOTS} aria-label="Promotional spots claimed" data-id="element-66" data-mp="226brrfaoehhu">
        <div className="scarcity-stripes h-full rounded-full bg-alert" style={{
        width: `${claimed}%`
      }} data-id="element-67" data-mp="cm8en25shdh" />
      </div>
      <div className="mt-2 flex justify-between text-xs font-semibold text-ink/60" data-id="element-68" data-mp="5bfkcb1ss0bj">
        <span data-id="element-69" data-mp="33ks614rzlxm8">{claimed}% claimed</span>
        <span data-id="element-70" data-mp="2zlt8i58l534t">Price goes up when full</span>
      </div>
    </div>;
}